export const CUSTOMERIO_SITE_ID = import.meta.env.VITE_CUSTOMERIO_SITE_ID;

export const CUSTOMERIO_SITE_ID_VALID = Boolean(
  CUSTOMERIO_SITE_ID && CUSTOMERIO_SITE_ID.length >= 10
);

const APP_STAGE = import.meta.env.VITE_APP_STAGE || 'dev';

export const CUSTOMERIO_CONFIG = {
  debug: APP_STAGE === 'dev',
  autoTrackPages: true,
  useInApp: true,
};
